import axios from 'axios'
import showToastify from '../utils/toastify'
import 'toastify-js/src/toastify.css'
import { find } from 'utils/dom'

export default function contatoForm() {
	const contatoFormSubmit = document.querySelector('#form-contato-home')
	if (!contatoFormSubmit) return

	const btnSubmit = contatoFormSubmit.querySelector('button[type=submit]')
	let recaptchaLoaded = false
	let recaptchaReady = false

	function showMessage(response) {
		const message = response.data ? response.data.message : response.message
		showToastify(message)
		contatoFormSubmit.reset()
		setTimeout(enabledBtn, 1000)
	}

	function disabledBtn() {
		btnSubmit.disabled = true
		btnSubmit.classList.add('disabled')
	}

	function enabledBtn() {
		btnSubmit.disabled = false
		btnSubmit.classList.remove('disabled')
	}

	function loadRecaptcha() {
		if (recaptchaLoaded) return

		console.log('carregou o  recaptcha')
		const script = document.createElement('script')
		script.src = `https://www.google.com/recaptcha/api.js?render=${window.site_key}`
		script.async = true
		script.defer = true
		script.onload = () => {
			recaptchaReady = true
		}
		document.body.appendChild(script)
		recaptchaLoaded = true
	}
	
	// 👇 Carrega o reCAPTCHA no primeiro foco em qualquer campo
	const inputs = contatoFormSubmit.querySelectorAll('input, textarea, select')
	inputs.forEach((input) => {
		input.addEventListener('focus', loadRecaptcha, { once: true })
	})

	// 👇 Lógica de envio
	contatoFormSubmit.addEventListener('submit', function (event) {
		event.preventDefault()
		disabledBtn()

		const formData = new FormData(contatoFormSubmit)
		const json = Object.fromEntries(formData.entries())

		const url = '/fale-conosco/'

		function sendRequestWithToken(token) {
			json['recaptcha_token'] = token

			axios
				.post(url, json)
				.then((response) => showMessage(response))
				.catch((response) => showMessage(response))
		}

		if (window.grecaptcha && recaptchaReady) {
			grecaptcha.ready(function () {
				grecaptcha.execute(window.site_key, { action: 'contato' }).then(sendRequestWithToken)
			})
		} else {
			loadRecaptcha() // tenta carregar se ainda não tiver carregado
			showToastify('Carregando reCAPTCHA... tente novamente em instantes.')
			enabledBtn()
		}
	})
}
